import React, { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from 'store';
import { tokenSelector } from 'store/auth/auth.selectors';
import ROUTES from 'constants/routes';
import styles from './UnAuthLayout.module.scss';

const UnAuthLayout: FC<PropsWithChildren> = ({ children }) => {
  const token = useAppSelector(tokenSelector);

  if (token) {
    return <Navigate to={ROUTES.HOME} replace />;
  }
  return (
    <div className={styles.wrapper}>
      {children}
    </div>
  );
};

export default UnAuthLayout;